/** GxTextField: a labelled text input with an optional hint; `invalid` sets aria-invalid. Style: `.gx-lbl` and `.gx-field` in theme.css. */
import type { InputHTMLAttributes, ReactNode } from "react";

export function GxTextField({ id, label, hint, invalid = false, ...input }: {
  readonly id: string; readonly label: string; readonly hint?: ReactNode; readonly invalid?: boolean;
} & Omit<InputHTMLAttributes<HTMLInputElement>, "id" | "className">) {
  return (
    <div>
      <label className="gx-lbl" htmlFor={id}>{label}</label>
      <input id={id} className="gx-field" aria-invalid={invalid || undefined} aria-describedby={hint === undefined ? undefined : `${id}-hint`} {...input} />
      {hint === undefined ? null : <div id={`${id}-hint`} className="gx-small gx-faint" style={{ marginTop: 6 }}>{hint}</div>}
    </div>
  );
}
